import validateFormattedCurrency from 'now-shared/validation/validateFormattedCurrency';

export default function validateBidAllowance(requestedBidAllowance) {
  return validateFormattedCurrency(requestedBidAllowance, {
    required: true,
    atLeast: 10,
  });
}
